const BinanceSmartChain = () => (
    <svg
        width='24'
        height='28'
        viewBox='0 0 24 28'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='bsc-icon'
    >
        <path
            d='M14.7073 23.2475V26.3912L11.959 28L9.29272 26.3912V23.2475L11.959 24.8563L14.7073 23.2475ZM0 12.3853L2.66623 13.9955V19.385L7.27285 22.1213V25.2585L0 20.9938V12.3853ZM23.9192 12.3853V20.9938L16.5656 25.2585V22.1213L21.1709 19.385V13.9955L23.9192 12.3853ZM16.5656 8.12196L19.3126 9.73078V12.8693L14.7073 15.6043V21.0717L12.0397 22.6805L9.37351 21.0717V15.6043L4.60661 12.8693V9.73078L7.35364 8.12196L11.959 10.857L16.5656 8.12196ZM4.60661 15.1216L7.27285 16.7305V19.8677L4.60661 18.2588V15.1216ZM19.3126 15.1216V18.2588L16.6464 19.8677V16.7305L19.3126 15.1216ZM2.66623 5.39085L5.41847 6.99578L2.67014 8.60461V11.7418L0.00390927 10.133V6.99578L2.66623 5.39085ZM21.2517 5.39085L24 6.99968V10.1369L21.2517 11.7457V8.60461L18.5802 6.99578L21.2517 5.39085ZM11.959 5.39085L14.7073 6.99968L11.959 8.6085L9.29272 6.99968L11.959 5.39085ZM11.959 0L19.3126 4.26468L16.6464 5.8735L12.0397 3.1372L7.34843 5.8735L4.6822 4.26468L11.959 0Z'
            fill='white'
        />
    </svg>
);

export default BinanceSmartChain;
